
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface BackfillCompanyLogosRequest {
    fromDate: Date;
    toDate: Date;
}

/**
 * 
 */
export class CompanyLogoBackfillApi extends runtime.BaseAPI {

    /**
     * Start the company logo backfill for the profiles created in the given period
          */
    async backfillCompanyLogosRaw(requestParameters: BackfillCompanyLogosRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['fromDate'] == null) {
            throw new runtime.RequiredError(
                'fromDate',
                'Required parameter "fromDate" was null or undefined when calling backfillCompanyLogos().'
            );
        }

        if (requestParameters['toDate'] == null) {
            throw new runtime.RequiredError(
                'toDate',
                'Required parameter "toDate" was null or undefined when calling backfillCompanyLogos().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = (requestParameters['fromDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = (requestParameters['toDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/company-logo/backfill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Start the company logo backfill for the profiles created in the given period
          */
    async backfillCompanyLogos(requestParameters: BackfillCompanyLogosRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.backfillCompanyLogosRaw(requestParameters, initOverrides);
    }

}
